import { inject, observer } from "mobx-react";
import { Route, Switch } from "react-router-dom";
import MainContainer from "containers/main/MainContainer";
import PosNotify from "../views/notify/PosNotifyView";
import AddressSearchForPosView from "../views/pos_support/AddressSearchForPosView";
import EmergnecyNotice from "../views/pos_support/EmergnecyNotice";
import SaleWriteView from "../views/pos_support/SaleWriteView";

const AppRoutes = () => {
  global.fn_pos_address_search = function () {
    window.location.href = "/search_address";
    return;
  };

  return (
    <Switch>
      {/* 메인 애플리케이션 라우트들 */}
      <Route exact path={"/"}>
        <MainContainer targetComponent="Main" />
      </Route>
      <Route exact path={"/order_list"}>
        <MainContainer targetComponent="MainOrderListContainer" />
      </Route>

      {/* 설정 관련 라우트들 */}
      <Route exact path={"/setting/end_order"}>
        <MainContainer targetComponent="SettingEndOrderView" />
      </Route>
      <Route path={"/setting/prod_soldout"}>
        <MainContainer targetComponent="SettingProdSoldoutView" />
      </Route>
      <Route path={"/setting/notice"}>
        <MainContainer targetComponent="SettingNoticeView" />
      </Route>

      {/* 기본 설정 라우트들 */}
      <Route path={"/setting/default/use"}>
        <MainContainer targetComponent="SettingDefaultUseView" />
      </Route>
      <Route path={"/setting/default/receipt"}>
        <MainContainer targetComponent="SettingDefaultReceiptView" />
      </Route>
      <Route path={"/setting/default/address"}>
        <MainContainer targetComponent="SettingDefaultAddressView" />
      </Route>
      <Route path={"/setting/default/delivery"}>
        <MainContainer targetComponent="SettingDefaultDeliveryView" />
      </Route>
      <Route path={"/setting/default/self_delivery"}>
        <MainContainer targetComponent="SettingDefaultSelfDeliveryView" />
      </Route>
      <Route path={"/setting/default/printer_setting"}>
        <MainContainer targetComponent="SettingDefaultPrinterView" />
      </Route>
      <Route path={"/setting/default/manager_setting"}>
        <MainContainer targetComponent="SettingDefaultManagerSetView" />
      </Route>
      <Route path={"/setting/default/request_memo"}>
        <MainContainer targetComponent="SettingDefaultRequestMemoView" />
      </Route>

      {/* 매출 관련 라우트들 */}
      <Route path={"/setting/sales/product"}>
        <MainContainer targetComponent="SalesProduct" />
      </Route>
      <Route path={"/setting/sales/time"}>
        <MainContainer targetComponent="SalesTime" />
      </Route>
      <Route path={"/setting/sales/calendar"}>
        <MainContainer targetComponent="SalesCalendar" />
      </Route>

      <Route path={"/notify/:orderNo"} component={PosNotify}></Route>
      <Route path={"/emergency_notice"} component={EmergnecyNotice}></Route>
      <Route path={"/sale_write"} component={SaleWriteView}></Route>
      <Route path={"/search_address"} component={AddressSearchForPosView}></Route>

      {/* 네이버 관련 라우트들 */}
      <Route path={"/naver/connected"}>
        <MainContainer targetComponent="NaverConnectedView" />
      </Route>
      <Route path={"/naver/disconnected"}>
        <MainContainer targetComponent="NaverDisconnectedView" />
      </Route>
      <Route path={"/naver/bizitem"}>
        <MainContainer targetComponent="NaverBizitemView" />
      </Route>
      <Route path={"/okgo/naver/callback"}>
        <MainContainer targetComponent="NaverCallback" />
      </Route>
      <Route path={"/okgo/naver/logout"}>
        <MainContainer targetComponent="NaverLogout" />
      </Route>
    </Switch>
  );
};

export default inject("rootStore")(observer(AppRoutes));
